import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { PUBLIC_ANCHORS, ROUTES } from '@/constants/routes';
import { cn } from '@/utils/cn';
import { useUserAuth } from '@/context/UserAuthContext';

const navLinks = [
  { label: 'Home', href: PUBLIC_ANCHORS.home },
  { label: 'Services', href: PUBLIC_ANCHORS.services },
  { label: 'About', href: PUBLIC_ANCHORS.about },
  { label: 'Contact', href: PUBLIC_ANCHORS.contact },
];

export function LandingNavbar() {
  const { isAuthenticated } = useUserAuth();
  const location = useLocation();
  const onLanding = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 border-b border-gray-100/80 bg-white/90 backdrop-blur-md">
      <div className="container-page flex h-16 items-center justify-between">
        <BrandLogo />

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={onLanding ? link.href : `${ROUTES.home}${link.href}`}
              className="text-sm font-medium text-brand-muted transition-colors hover:text-brand-navy"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {isAuthenticated ? (
            <Link to={ROUTES.dashboard}>
              <Button size="sm">Dashboard</Button>
            </Link>
          ) : (
            <>
              <Link to={ROUTES.login} className="hidden text-sm font-medium text-brand-navy sm:block">
                Login
              </Link>
              <Link to={ROUTES.register}>
                <Button size="sm">Register</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export function BrandLogo({
  className,
  subtitle,
}: {
  className?: string;
  /** Optional line under the brand name (e.g. user type on mobile navbar). */
  subtitle?: string;
}) {
  return (
    <Link to={ROUTES.home} className={cn('inline-flex items-center gap-2.5 sm:gap-3', className)}>
      <img
        src="/assets/logo-dark.jpeg"
        alt="AS DataLink"
        className="h-9 w-9 shrink-0 rounded-lg object-cover sm:h-10 sm:w-10"
        width={40}
        height={40}
      />
      <span className="min-w-0 leading-tight">
        <span className="block text-base font-bold tracking-tight sm:text-lg">
          <span className="text-primary">AS</span>
          <span className="text-secondary">DATALINK</span>
        </span>
        {subtitle ? (
          <span className="mt-0.5 block text-[10px] font-semibold capitalize text-secondary sm:text-[11px]">
            {subtitle}
          </span>
        ) : null}
      </span>
    </Link>
  );
}
